/**
 * @fileOverView
 * @description Form Text Input View<br>
 * @copyright 2015-present Flatirontek LLC
 **/

const VybTest = require("../../models/vybtest");
const app = require('ampersand-app');
const AmpersandView = require('ampersand-view');
const logText = require('../../../../lib/logtext');
const safeHtml = require('../../lib/safehtml');

//a derived developer field renders from app.developer, not from this.model, so
//it has to be told which source props to re-render on. Add new ones here.
const DEVELOPER_DERIVED_DEPS = {
    maskedClientSecret: ['oauth_client_secret'],
    maskedApiKey: ['api_key'],
    maskedWebhooksSecret: ['webhooks_secret'],
    webhooksInstructions: ['webhooks_secret', 'webhooks'],
    oauth_redirect_uri_1: ['oauth_redirect_uris', 'oauth_redirect_uri'],
    oauth_redirect_uri_2: ['oauth_redirect_uris', 'oauth_redirect_uri'],
    oauth_redirect_uri_3: ['oauth_redirect_uris', 'oauth_redirect_uri']
};

const VparamView = AmpersandView.extend({

    template: app.templates.DisplayTemplate,

    bypassBlurSave: false,

    initialize: function(){
               this.listenTo(this.model,'change:editing',function(){
                   this.render();
               } );

               //keep moderation display updated
               if(this.model.name==="moderationDisplay"){
                   this.listenTo(app.vyb,'change:access', function(){
                       this.render();
                   } );
               }

               //keep these updated
               if((this.model.name==="eventUri"
                   || this.model.name==="schedule"
                   || this.model.name==="geofenceDisplay"
                   || this.model.name==="reminders"
                   || this.model.name==="soundName"
                   || this.model.name=="subscriptionLinks") && app.vyb){
                   this.listenTo(app.vyb,'change:' + this.model.name, function(){
                       this.render();
                   } );

                   this.listenTo(app.vyb,'change:triggerType', function(){
                       this.render();
                   } );
               }

               if(this.model.name==="soundName" && app.vyb){
                   this.listenTo(app.vyb,'change:soundKey', function(){
                       this.render();
                   } );
               }

               //notification fields - listen to changes for vyb
               if((this.model.name==="message" || this.model.name==="log" || this.model.name==="imageUrl" || this.model.name==="linkUrl") && this.model.entity==="vyb" && app.vyb){
                   this.listenTo(app.vyb,'change:' + this.model.name, function(){
                       this.render();
                   });
               }

               //notification fields - listen to changes for vybfollowing
               if((this.model.name==="message" || this.model.name==="imageUrl" || this.model.name==="linkUrl") && this.model.entity==="vybfollowing" && app.vybfollowing){
                   this.listenTo(app.vybfollowing,'change:' + this.model.name, function(){
                       this.render();
                   });
               }

               //developer fields - listen to changes
               if(this.model.entity==="developer" && app.developer){
                   var deps = DEVELOPER_DERIVED_DEPS[this.model.name];
                   if(deps) deps.forEach(function(dep){
                       this.listenTo(app.developer, 'change:' + dep, function(){
                           this.render();
                       });
                   }, this);
               }
    },

    render: function(){
        let value = "";

        //vyb specific
        if(this.model.entity=="vyb" && app.vyb[this.model.name]!=null && app.vyb[this.model.name].length>0){
            value = app.vyb[this.model.name];
            this.model.displayPlaceholder = false;

        //new vyb
        }else if(this.model.entity=="vyb" && (app.vyb.get(this.model.name)==null || app.vyb.get(this.model.name).length==0) && this.model.placeholder!=undefined) {
            value = this.model.placeholder;
            this.model.displayPlaceholder = true;

        //vybfollowing specific
        }else if(this.model.entity=="vybfollowing" && app.vybfollowing && app.vybfollowing[this.model.name]!=null){
            value = app.vybfollowing[this.model.name];
            this.model.displayPlaceholder = false;

        //new vybfollowing (shouldn't happen but handle gracefully)
        }else if(this.model.entity=="vybfollowing" && app.vybfollowing && app.vybfollowing.get(this.model.name)==null && this.model.placeholder!=undefined) {
            value = this.model.placeholder;
            this.model.displayPlaceholder = true;

        //developer specific
        }else if(this.model.entity=="developer" && app.developer && app.developer[this.model.name]!=null && app.developer[this.model.name].length>0){
            value = app.developer[this.model.name];
            this.model.displayPlaceholder = false;

        //new developer
        }else if(this.model.entity=="developer" && app.developer && (app.developer.get(this.model.name)==null || app.developer.get(this.model.name).length==0) && this.model.placeholder!=undefined) {
            value = this.model.placeholder;
            this.model.displayPlaceholder = true;

        //profile specific
        }else if(this.model.entity=="profile" && app.profile && app.profile[this.model.name]!=null && app.profile[this.model.name].length>0){
            value = app.profile[this.model.name];
            this.model.displayPlaceholder = false;

        //profile field not set yet (e.g. optional org name)
        }else if(this.model.entity=="profile" && app.profile && (app.profile.get(this.model.name)==null || app.profile.get(this.model.name).length==0) && this.model.placeholder!=undefined) {
            value = this.model.placeholder;
            this.model.displayPlaceholder = true;

        //display
        }else if(!this.model.editing && this.model.displayName!=undefined && app[this.model.entity] && app[this.model.entity][this.model.displayName]!=undefined){
            value = app[this.model.entity][this.model.displayName];

        //misc (handles derived properties like buttonDisplay)
        } else if (app?.[this.model.entity]?.[this.model.name] != null) {
            value = app[this.model.entity][this.model.name];

        }

        this.model.value = value != null ? value.toString() : "";
        //the display binding writes each value into the page as html as soon as it is set
        this.model.display = this.displayFor(this.model.value);

        //edit mode
       if(this.model.editing || this.model.inputType=="button"){
            this.template = app.templates[this.model.template];

        //display mode
        }else{
            this.template = app.templates.DisplayTemplate;
            if(this.model.name=="diagnostics"){
                this.model.value = app.vyb.diagnostics.toString();
                this.model.display = logText.escapeHtml(YAML.stringify(app.vyb.diagnostics)).replace("response","<br/>response");
            }
        }

        this.renderWithTemplate();
        this.postRenderStuff();
    },

    //the html a param shows. Notification defaults are stored as sent through the API, so they are
    //cleaned here: the message keeps its limited html, the log is plain text, the urls show as text
    displayFor: function(value){
        const name = this.model.name;
        if(name=="frequency") return app.vyb.displayFrequency;
        if(name=="sendPermissions") return app.vyb.sendPermissionsDisplay;
        if(this.model.displayPlaceholder || (this.model.entity!="vyb" && this.model.entity!="vybfollowing")) return value;
        if(name=="message") return safeHtml.sanitize(value);
        //a link opens in a new tab rather than putting the field into edit mode
        if(name=="log") return logText.textToHtml(value, ' target="_blank" onclick="app.utils.cancelBubble()"');
        if(name=="imageUrl" && /^https?:\/\//i.test(value)) return '<img class="vlogimg" src="' + logText.escapeHtml(value) + '" />';
        if(name=="linkUrl" || name=="imageUrl") return logText.escapeHtml(value);
        return value;
    },

    postRenderStuff: function(){

        if(this.model.editing==true){
            if(this.model.value==this.model.placeholder) this.model.value="";
            if(this.model.entity=="vyb" && this.model.inputType=="select"){
                var selectEl = this.el.querySelector("select[data-param='frequency']," +
                    "select[data-param='type']," +
                    "select[data-param='access']," +
                    "select[data-param='triggerType']," +
                    "select[data-param='sendPermissions']"
                );
                if(selectEl){
                    var optionEl = selectEl.querySelector("option[value='"+this.model.value+"']");
                    if(optionEl) optionEl.selected = 'selected';
                }
            }

            var self = this;
            if(this.model.inputType!="button") setTimeout(
                function(){ if(self.el.querySelector(".vedit")!=null) self.el.querySelector(".vedit").focus(); },
                10);

            //schedule trigger
            if(this.model.name==="schedule") app.utils.configScheduleSettings('current',this);

            //geofence trigger
            if(this.model.name==="geofenceDisplay") app.utils.configGeofenceSettings(this);

            //reminders trigger
            if(this.model.name==="reminders") app.utils.configReminderSettings(this);

            app.utils.setDisplayMode();
        }
    },

    bindings: {

        "model.name" : [{
            type: "attribute",
            name: "data-param",
            selector: ".vedit"
        }, {
            type: "attribute",
            name: "data-param",
            selector: "div.vparam"
        }],

        "model.value" : {
            type: "value",
            selector: ".vedit"
        },
        "model.maxLength" : {
            type: "attribute",
            name: "maxlength",
            selector: "textarea.vedit"
        },
        "model.display" : {
            type: "innerHTML",
            selector: "div.vparam"
        },
        "model.cursor" : {
            type: function(el, value) {
                // cursor: false means no pointer cursor (add vnone class)
                // cursor: true or undefined means pointer cursor (remove vnone class)
                if (value === false) {
                    el.classList.add('vnone');
                } else {
                    el.classList.remove('vnone');
                }
            },
            selector: "div.vparam"
        },
        "model.displayPlaceholder" : {
            type: "booleanClass",
            name: "vplaceholder",
            selector: "div.vparam"
        },

        //for vyb send
        "model.shakeElement" : {
            type: "booleanClass",
            name: "vybshake",
            selector: "button.vybtest > span"
        }
    },

    events: {
        "click div.vparam" : "editParam",
        "blur input,textarea,select" : "saveParamOnBlur",
        "change select" : "saveParam",
        "keypress" : "saveOnEnter",
        "mousedown button.vybtest" : "sendVyb",
        "mousedown button.vybsend" : "sendVyb",
        "click .vts-cancel" : "cancelSave",
        "click .vts-close" : "cancelSave"
    },

    cancelSave: function(){
        app.vyb.set('editing',false);
        app.header.set('editing',false);
        this.model.set('editing',false);
    },

    editParam: function(){

        if(this.model.type=="none"
            || this.model.type=="button"
            ||(app.currentPageName=="VybPage" && app.vyb.name==undefined && this.model.name!="name")
            || (this.model.bypassSave && app.header.get("editing")===true)
        ) return;

        if(this.model.inputType=="page"){
            if(this.model.name=='soundName'){
                var view =   new app.SoundsPageView({mode:"vyb", model: app.vyb });
            }else if(this.model.name=='displayFollowers'){
                var view =   new app.PeepsPageView({mode:"vyb", model: app.vyb });
            }
            app.pageSwitcher.set(view);
            return;
        }

        // Reset bypassBlurSave when entering edit mode
        this.bypassBlurSave = false;

        app.header.set({editing:true});
        this.model.set({editing:true});

        if(this.model.bypassSave==true) app.header.set("bypassSave",true);
    },

    saveParam: function(){

        if(this.model.bypassSave && app.header.get("editing")===true) return;

        var prop = this.model.name;
        var curVal = this.model.value;
        var inputVal = null;
        if(this.el.querySelector("[data-param='"+prop+"']")!=null
            && this.el.querySelector("[data-param='"+prop+"']")!=undefined){
            inputVal = this.el.querySelector("[data-param='"+prop+"']").value;
        }

        if(prop=="name" || prop=="description") inputVal = logText.stripTags(inputVal);

        if(curVal==inputVal){
            this.model.set('editing',false);
            app.header.set('ignoreclick',true);
            app.header.set('editing',false);
            return;
        }

        this.bypassBlurSave = true;

        var data = {};
        data[this.model.name] = inputVal;
        app[this.model.entity].patch(data, this.model);

    },

    saveOnEnter: function(event){
        if(this.model.inputType!="textarea" && event.keyCode===13){
            this.bypassBlurSave = true;
            this.saveParam();
        }
    },

    saveParamOnBlur: function(){

      if(this.bypassBlurSave){
          this.bypassBlurSave = false;
          return;
      }

      this.saveParam();
    },

    sendVyb: function(){

        var self = this;

        // If a param is being saved, wait for it to complete before sending
        // Using mousedown event ensures this fires before blur/saveParam
        if (app.header.get('editing') === true) {

            var executed = false;

            var executeOnce = function() {
                if (!executed) {
                    executed = true;
                    self.executeSendVyb();
                }
            };

            var onEditingDone = function() {
                if (app.header.get('editing') === false) {
                    app.header.off('change:editing', onEditingDone);
                    executeOnce();
                }
            };

            app.header.on('change:editing', onEditingDone);

            // Race condition guard: if editing completed before listener attached, send immediately
            setTimeout(function() {
                if (app.header.get('editing') === false) {
                    app.header.off('change:editing', onEditingDone);
                    executeOnce();
                }
            }, 50);

            return;
        }

        // No save in progress, send immediately
        this.executeSendVyb();
    },

    executeSendVyb: function(){

        if(this.model.entity === 'vybfollowing') {
            const vybFollowingView = this.parent && this.parent.parent;
            if(vybFollowingView && vybFollowingView.executeSendNotification){
                vybFollowingView.executeSendNotification();
                return;
            }
        }

        if(!app.vyb) {
            console.error('app.vyb is not available');
            return;
        }

        app.vyb.testing = true;

        var vyb = app.vyb
        var test = new VybTest({triggerKey: vyb.triggerKey, type:vyb.type});
        var request = vyb.type=="event" ? vyb.eventUri : vyb.pollUri;
        this.model.set("pinging",true);
        var self = this;

        test.fetch({
            success: function(model,response){
                var diagnostics = {request:request, response: response};
                vyb.set("diagnostics",diagnostics);
                self.model.set("pinging",false);
            },
            error: function(model,response){
                console.log(response);
                var diagnostics = {request:request, response: response.body};
                vyb.set("diagnostics",diagnostics);
                self.model.set("pinging",false);
                //TODO, redirect to log if account suspended
            }
        });
    }
});

module.exports = VparamView;
